<template>
  <div class="pagination" :style="{ margin: margins }">
    <router-link
      :to="{ query: { ...$route.query, page: previousPage } }"
      :replace="true"
      class="pagination__link"
      v-if="previousPage"
      ><</router-link
    >
    <a v-else class="pagination__link"><</a>
    <router-link
      v-for="page in pages"
      :key="page"
      :to="{ query: { ...$route.query, page: page } }"
      :replace="true"
      class="pagination__link"
      >{{ page }}</router-link
    >
    <router-link
      :to="{ query: { ...$route.query, page: nextPage } }"
      :replace="true"
      class="pagination__link"
      v-if="nextPage"
      >></router-link
    >
    <a v-else class="pagination__link">></a>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'pagination',
  props: {
    flats: { type: Array, required: true },
    mb: { type: Boolean, default: true },
    mt: { type: Boolean, default: true },
  },
  computed: {
    ...mapState({ flatsOnPage: state => state.browser.flatsOnPage }),
    pages() {
      return Math.ceil(this.flats.length / this.flatsOnPage);
    },
    previousPage() {
      let page = this.$route.query.page;
      if (page > 1 && page) {
        return page - 1;
      }
      return false;
    },
    nextPage() {
      let page = this.$route.query.page;
      if (page < this.pages && page) {
        return page + 1;
      } else if (!page && this.pages > 1) {
        return 2;
      }
      return false;
    },
    margins() {
      return `${this.mt == true ? 20 : 0}px 0  ${this.mb == true ? 20 : 0}px 0`;
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  overflow-x: auto;
}

.pagination__link {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid $lightGray;
  border-radius: 6px;
  background: #fff;
  width: 35px;
  min-width: 35px;
  height: 35px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  color: #000;
  transition: 200ms;

  margin: {
    left: 5px;
    right: 5px;
  }

  &.active--exact {
    border: 1px solid $primaryColor;
  }
}
</style>
